import React from 'react';

import About from '../pages/About'
import {Contact} from '../pages/Contact'
import {Work} from '../pages/Work';
import Home from '../pages/Home';
import Hotels from '../pages/Hotels';
import DynamicGallery from './DynamicGallery';

//import routes rouate & uselocation hook
import {Routes, Route, useLocation} from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

const AnimRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence initial={true} mode='wait'>
      <Routes key={location.pathname} location={location}>
        <Route path='/about' element={<About />} />
        <Route path='/' element={<Home />} />
        <Route path='/portfolio' element={<Work />} />
        <Route path='/portfolio/places' element={<Work />} />
        <Route path='/portfolio/people' element={<Work />} />
        <Route path='/portfolio/other' element={<Work />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/hotels' element={<Hotels />} />
        <Route path='/graduation' element={<DynamicGallery folder='graduation' />} />
        <Route path='/portraits' element={<DynamicGallery folder='portraits' />} />
        <Route path='/italy' element={<DynamicGallery folder='italy' />} />
        <Route path='/como' element={<DynamicGallery folder='como' />} />
        <Route path='/yellowstone' element={<DynamicGallery folder='yellowstone' />} />
        <Route path='/boston' element={<DynamicGallery folder='boston' />} />
        <Route path='/newengland' element={<DynamicGallery folder='newengland' />} />
        <Route path='/architecture' element={<DynamicGallery folder='architecture' />} />
        <Route path='/cars' element={<DynamicGallery folder='cars' />} />
        <Route path='/nice' element={<DynamicGallery folder='nice' />} />
        <Route path='/cotedazur' element={<DynamicGallery folder='cotedazur' />} />
        <Route path='/summeralps' element={<DynamicGallery folder='lower_alps' />} />
        <Route path='/newyorkcity' element={<DynamicGallery folder='newyorkcity' />} />
        <Route path='/interiors' element={<DynamicGallery folder='interiors' />} />
        <Route path='/winteralps' element={<DynamicGallery folder='alps' />} />
        <Route path='/film' element={<DynamicGallery folder='film' />} />
        <Route path='/groups' element={<DynamicGallery folder='groups' />} />
        <Route path='/hawaii' element={<DynamicGallery folder='hawaii' />} />
        <Route path='/croatia' element={<DynamicGallery folder='croatia' />} />
        <Route path='/oslo' element={<DynamicGallery folder='oslo' />} />
        <Route path='/stockholm' element={<DynamicGallery folder='stockholm' />} />
        <Route path='/copenhagen' element={<DynamicGallery folder='copenhagen' />} />
        <Route path='/netherlands' element={<DynamicGallery folder='netherlands' />} />
        <Route path='/sgxv' element={<DynamicGallery folder='sgxv' />} />
        <Route path='/bordeaux' element={<DynamicGallery folder='bordeaux' />} />
        <Route path='/vienna' element={<DynamicGallery folder='vienna' />} />
        <Route path='/paris' element={<DynamicGallery folder='paris' />} />
        <Route path='/spain' element={<DynamicGallery folder='spain' />} />
        <Route path='/canaryislands' element={<DynamicGallery folder='canaryislands' />} />
        <Route path='/greece' element={<DynamicGallery folder='greece' />} />
        <Route path='/france' element={<DynamicGallery folder='france' />} />
        <Route path='/portugal' element={<DynamicGallery folder='portugal' />} />
      </Routes>
    </AnimatePresence>
    
  );
};

export default AnimRoutes;
